import { createApiClient } from '@recipes/api-client';
import { SHOPPING_CLIENT_ID_HEADER } from '@recipes/contracts';
import { authStore } from './auth/auth-store';
import i18n from './i18n';

export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';

/**
 * Identifies this tab in live shopping-list events, so a client can tell its own changes from
 * those of other people (and of the same person on another device).
 */
export const CLIENT_ID =
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `c-${Date.now().toString(36)}`;

/**
 * Singleton API client. The access token lives only in memory (auth store); on 401 the
 * client asks the auth store to refresh via the HttpOnly cookie and retries once.
 */
export const api = createApiClient({
  baseUrl: API_BASE_URL,
  getAccessToken: () => authStore.getState().accessToken,
  refresh: () => authStore.getState().refresh(),
  headers: () => ({
    'Accept-Language': i18n.language || 'de',
    [SHOPPING_CLIENT_ID_HEADER]: CLIENT_ID,
  }),
});

export type Api = typeof api;
